import styled, { css } from 'styled-components';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

import { ReactComponent as ChevronSvg } from '@/assets/icons/chevron.svg';

export const Wrapper = styled.div<{ $isSpaceBetween?: boolean }>`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  max-width: 1000px;
  text-transform: uppercase;
  ${({ $isSpaceBetween, theme }) => css`
    justify-content: ${$isSpaceBetween ? 'space-between' : 'center'};
    margin-bottom: ${theme.spacing(8)};
  `}
`;

export const Navigations = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .NavigationsTitle {
      margin-right: ${theme.spacing(1.5)};
      margin-left: 0;
    }
    .LinksBox {
      flex-direction: row;
      svg {
        transform: rotate(0);
      }
    }
    &:nth-child(2n + 1) {
      align-items: flex-start;
      .NavigationsTitle {
        margin-left: ${theme.spacing(1.5)};
        margin-right: 0;
      }
      .LinksBox {
        flex-direction: row-reverse;
        svg {
          transform: rotate(180deg);
        }
      }
    }
  `}
`;

export const NavigationsTitle = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    font-size: ${theme.spacing(3)};
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.almostBlack};
    font-weight: 600;
  `}
`;
export const Links = styled(LinkWithLocale)`
  ${({ theme }) => css`
    text-decoration: underline;
    text-underline-offset: 5px;
    text-decoration-color: ${theme.colors.primary};
    text-decoration-thickness: 1px;
    font-size: 14px;
    font-family: ${theme.fontFamilies.italianPlate};
    color: ${theme.colors.primaryDark};
    line-height: 22px;
  `}
`;
export const LinksBox = styled.div<{ $isSpaceBetween: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme }) => css`
    margin-top: ${theme.spacing(0.5)};
  `}
`;

export const Chevron = styled(ChevronSvg)`
  fill: ${({ theme }) => theme.colors.primaryDark};
  vertical-align: middle;
`;
